import styles from "./ProgressCircle.module.css";

interface ProgressCircleProps {
	percentage?: number;
}

const RADIUS = 28;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export function ProgressCircle({ percentage = 33 }: ProgressCircleProps) {
	// Clamp so out-of-range input can't produce a negative/overflowing dashoffset.
	const safePercentage = Math.min(100, Math.max(0, percentage));
	const dashoffset = CIRCUMFERENCE * (1 - safePercentage / 100);

	return (
		<div className={styles.container}>
			<svg
				className={styles.svg}
				viewBox="0 0 72 72"
				role="img"
				aria-label={`${safePercentage}% progress`}
			>
				<defs>
					<filter id="trackInset">
						<feOffset dx="0" dy="1" />
						<feGaussianBlur stdDeviation="1.5" result="blur" />
						<feFlood floodColor="#b0b0c0" floodOpacity="0.5" result="color" />
						<feComposite in="color" in2="blur" operator="in" result="shadow" />
						<feComposite in="shadow" in2="SourceGraphic" operator="over" />
					</filter>
				</defs>
				{/* Track ring with sunken/inset effect */}
				<g className={styles.ringGroup}>
					<circle
						className={styles.trackCircle}
						cx="36"
						cy="36"
						r={RADIUS}
						strokeWidth="10"
						fill="none"
						filter="url(#trackInset)"
					/>
					<circle
						className={styles.progressCircle}
						cx="36"
						cy="36"
						r={RADIUS}
						strokeWidth="10"
						fill="none"
						strokeDasharray={CIRCUMFERENCE}
						strokeDashoffset={dashoffset}
						strokeLinecap="round"
					/>
				</g>
				{/* White center */}
				<circle className={styles.centerCircle} cx="36" cy="36" r="21" />
				<text
					className={styles.percentageText}
					x="36"
					y="36"
					textAnchor="middle"
					dominantBaseline="central"
				>
					{percentage}%
				</text>
			</svg>
		</div>
	);
}
